import UI from 'root/ui';
import Cache from 'root/cache';
import PDFJS from 'root/module/pdfjs';
import View from 'view/base';

export default View.extend({
    className: 'pdf-pagination',

    total_pages: 0,
    current_page: 1,

    events: {
        'click .prev': 'prev',
        'click .next': 'next'
    },

    dom_handlers: {
        prev: function(e) {
            this.current_page--;
            this.current_page = Math.max(this.current_page, 1);

            this.render();

            this.dispatcher.trigger('Pdf_Thumbnail:Select', this.current_page - 1);
        },

        next: function(e) {
            this.current_page++;
            this.current_page = Math.min(this.current_page, this.total_pages);

            this.render();

            this.dispatcher.trigger('Pdf_Thumbnail:Select', this.current_page - 1);
        }
    },

    event_handlers: {
        onScroll: function(direction) {
            if (direction > 0) {
                this.$el.find('.next').click();
            } else {
                this.$el.find('.prev').click();
            }
        }
    },

    initialize: function(options) {
        this.dispatcher = options.dispatcher;

        this.dispatcher.on('Pdf:Scroll', this.event_handlers.onScroll.bind(this));
    },

    loadInfo: function() {
        var loading_task = PDFJS.getInstance().getDocument(this.model.get('screenshot'));
        loading_task.promise.then(function(pdf) {
            this.total_pages = pdf.numPages;
            this.render();
        }.bind(this), function(reason) {
            UI.error(reason);
        });
    },

    render: function(options) {
        var content = '';

        if (this.total_pages) {
            content += '<button class="primary primary-invert small prev"><i class="far fa-angle-left"></i></button>';
            content += '<button class="primary primary-invert small tooltip" data-title="Page ' + this.current_page +'">Page ' + this.current_page + ' / ' + this.total_pages + '</button>';
            content += '<button class="primary primary-invert small next tooltip"><i class="far fa-angle-right"></i></button>';
        }

        this.$el.html(content);

        if (!this.total_pages) {
            this.loadInfo();
        }

        return this;
    }
});